import { Fragment } from "react";

import { AisSitesType } from "@/libraries/bxp-web-stargate-client/src/index";

import ExploreMoreSection from "./explore-more-section";
import LogMeInSection from "./log-me-in";

interface HeroSectionProps {
    confluenceSites: AisSitesType[];
    userProfileName: string | undefined;
}

export const HeroSection = ({ ...props }: HeroSectionProps) => {
    return (
        <Fragment>
            <LogMeInSection {...props} />
            <ExploreMoreSection />
        </Fragment>
    );
};

export default HeroSection;
